import tinyColor from "tinycolor2";

export function isValidColor(color: string) {
  return tinyColor(color).isValid();
}

export function convertToHex(color: string) {
  return tinyColor(color).toHexString();
}
